import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTTable from "general/components/OtherKeenComponents/KTTable";
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import EmptyView from "general/components/Others/EmptyView";
import AppColors from 'general/constants/AppColors';
import AppConstants from "general/constants/AppConstants";
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from "general/helpers/UIHelper";
import Utils from 'general/utils/Utils';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';


function MaintainerTicketHistoryView(props) {
    // ---- params ----
    const { ticketDetail } = props;
    const { user } = useSelector((state) => state.auth);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const [ticketHistoryList, setTicketHistoryList] = useState([]);

    const columns = useMemo(() => {
        return [
            {
                name: UIHelper.buildTableColumn('Mã kỹ thuật viên'),
                selector: (row) => (
                    <span onClick={()=>Utils.openInNewTab(`${AppRoute.maintainerList}/${row.user?.agency?.agencyId}`)}>
                        {row?.user?.agency?.agencyCode ?? (row.user?.agency?.agencyId)}
                    </span>
                ),
                style: tableStyle.columns.link,
                width: '150px',
            },
            {
                name: UIHelper.buildTableColumn('Tên kỹ thuật viên'),
                width: '240px',
                selector: (row) => row?.user?.fullname,
                style: tableStyle.columns.normal,
            },
            {
                name: UIHelper.buildTableColumn('Thời gian nhận việc'),
                selector: (row) => Utils.formatDateTimeToString(row?.assignedAt,'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                width: '160px',
            },
            {
                name: UIHelper.buildTableColumn('Thời gian từ chối'),
                selector: (row) => Utils.formatDateTimeToString(row?.cancelledAt,'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                width: '160px',
            },
            {
                name: UIHelper.buildTableColumn('Lý do từ chối'),
                selector: (row) => row?.cancelReason,
                style: tableStyle.columns.normal,
                minWidth: '240px',
                wrap: true,
            },
        ];
    }, [user, adminRole]);

    useEffect(() => {
        getTicketHistoryList();
    }, [ticketDetail]);

    // ---- methods ----
    const getTicketHistoryList = () => {
        const params = {
            ticketId: ticketDetail?.ticketId,
        };

        try {
            MaintainerHelper.API.requestGetTicketHistoryList(params).then((data) => {
                const { ticketHistories } = data;
                setTicketHistoryList(ticketHistories);
            });
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    };


    return (
        <div className='mt-4 m-0'>
            {UIHelper.buildCard(
                <div className='p-4'>
                    <div className='mb-2' style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                        Nhật ký phân phối & nhận việc
                    </div>
                    <KTTable
                        columns={columns}
                        items={ticketHistoryList}
                        selectableRows={false}
                        striped={false}
                        compactGrid={false}
                        onClickedRow={(row) => { }}
                        onSelectedRowsChanged={(rows) => { }}
                        onDoubleClickedRow={(rows) => { }}
                        noDataComponent={
                            <EmptyView
                                icon={imgEmptyNoData}
                                title="Không có dữ liệu để hiển thị"
                                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                            />
                        }
                    />
                </div>
            )}
        </div>
    )
}

export default MaintainerTicketHistoryView;